<i18n>
{
    
    "en": {
        "copyrights": "Four Seasons - All rights reserved.",
        "created-by": "This website developed by Aavani Info Team - ",
        "links": "Navigation:",
        
        "contact": {
            "subheader": "Contact us via:",
            "email": "Email Address",
            "address": "Address",
            "website": "Website"
        }
    }
}
</i18n>
<template>
  <footer
    class="e-footer footer-bg strong-text--text"
    :class="{ phone: phoneOnly }"
  >
    <v-container
      data-aos="fade-up"
      data-aos-duration="600"
      class="row-container text--text py-10"
    >
      <v-row>
        <template>
          <v-col :cols="pcOnly ? 6 : 12" class="ps-lg-12">
            <contact-form
              data-once
              :data-aos="'fade'"
              :data-aos-duration="800"
            />
          </v-col>
          <v-col :cols="pcOnly ? 6 : 12" class="ps-lg-12">
            <div id="iframe-wrapper">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m8!1m3!1d3916.7718864859926!2d78.03225!3d10.9805833!3m2!1i1024!2i768!4f13.1!4m6!3e6!4m0!4m3!3m2!1d10.9805833!2d78.03224999999999!5e0!3m2!1sen!2sin!4v1688318301205!5m2!1sen!2sin"
                width="600"
                height="450"
                style="border:0;"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </v-col>
        </template>
      </v-row>
      <hr class="mt-5" />
      <v-row class="mt-5">
        <v-col
          :cols="pcOnly ? 4 : 12"
          class="pe-lg-12"
          :class="{
            'd-flex text-center justify-center align-center flex-column': phoneOnly,
          }"
        >
          <logo :light="false" :width="pcOnly ? 500 : 125" />
        </v-col>
        <v-col :cols="pcOnly ? 4 : 12" class="px-lg-12">
          <v-subheader class="blue--text"> {{ $t("links") }} </v-subheader>
          <v-list color="footer-bg">
            <v-list-item
              v-for="link in links"
              :key="link.name"
              large
              tile
              text
              class="ms-2"
              @click="navigateToLink(link.ref)"
            >
              <v-list-item-title class="strong-text--text">{{
                $t(`links.${link.name}`)
              }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col :cols="pcOnly ? 4 : 12" class="ps-lg-12">
          <v-subheader class="blue--text">
            {{ $t("contact.subheader") }}
          </v-subheader>
          <v-list color="footer-bg" dark class="text--text" two-line>
            <v-list-item
              v-for="item in contactItems"
              :key="item.name"
              :target="item.href ? '_blank' : ''"
              :href="
                item.href
                  ? item.href
                  : item.name === 'email'
                  ? `mailto:${item.value}`
                  : ''
              "
            >
              <v-list-item-icon>
                <v-icon :color="item.color">{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle class="mb-2">{{
                  $t("contact." + item.name)
                }}</v-list-item-subtitle>
                <v-list-item-content>{{ item.value }}</v-list-item-content>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
    <v-spacer />
    <div class="footer-watermark flex-column">
      <v-container class="text-center py-0">
        <div>© 2023 {{ $t("copyrights") }}</div>
        <div class="details-text white--text mt-3">
          {{ $t("created-by") }}
          <v-btn
            color="#f56607"
            class="white--text"
            :x-small="pcOnly"
            href="http://www.aavaniinfo.com/contact.html"
            target="_blank"
            >contact Aavani</v-btn
          >
        </div>
      </v-container>
    </div>
  </footer>
</template>

<script>
import GlobalComputed from "@/helpers/global-computed";
import GlobalMethods from "@/helpers/global-methods";
import ContactForm from "@/components/custom/contact-form";
import links from "@/helpers/links";
import Logo from "./logo";

export default {
  name: "e-footer",
  props: {
    light: {
      type: Boolean,
      default: false,
    },
  },
  components: { ContactForm, Logo },

  data() {
    return {
      links,
      contactItems: [
        {
          name: "email",
          icon: "mdi-email",
          value: "senthil@four-seasons.in",
          color: "white",
        },
        {
          name: "address",
          icon: "mdi-map",
          value:
            "162/2, AndanKovil West Village, Athur Pirivu, Athur, Karur 639002. INDIA.",
          color: "white",
        },
        {
          name: "website",
          icon: "mdi-web",
          value: "www.four-seasons.in",
          color: "white",
          href: "",
        },
      ],
    };
  },
  computed: {
    ...GlobalComputed,
  },
  methods: {
    ...GlobalMethods,
  },
};
</script>
<style lang="scss" scoped>
.e-footer {
  min-height: 500px;
  display: flex;
  justify-content: center;
  align-content: stretch;
  flex-direction: column;

  &.phone {
    min-height: 400px;
  }

  .footer-watermark {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #5f5e5e;
    line-height: 1.6rem;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 2rem 0;
  }
  .row-container {
    line-height: 1.9rem;
  }
}
</style>
